/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
export class MisValesAhorroMockProvider {
  pojos = [
    {
      tipoLista: 1,
      numOferta: '01216',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030141600016',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '5',
      textoTitulo: 'en TABLETAS de CHOCOLATE NEGRO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '801.000',
      codImpacto: '996',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Perfumeria',
          categoria: 'HIGIENE Y CUIDADO CAPILAR',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01213',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030141300013',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '5',
      textoTitulo: 'en CACAO en POLVO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '111.100',
      codImpacto: '999',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Dulce',
          categoria: 'PRODUCTOS SALUD',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01208',
      fechaIniVigencia: 1670886000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040140800008',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '1,50',
      textoTitulo: 'en YOGURES',
      textoDescripcion1: 'Aplicable a 24 packs máximo. Canjeable en Hiper EROS',
      textoDescripcion2: 'KI, Super EROSKI/center, EROSKI/city o EROSKI/online',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '50.100',
      codImpacto: '11',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Carta generica',
      denominacionSoportePostal: 'Carta generica',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Libre servicio',
          categoria: 'HELADO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Tue Dec 13 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01228',
      fechaIniVigencia: 1670108400000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030142800028',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en BOLSITAS y TARRITOS de FRUTAS o VERDURAS',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '30.000',
      codImpacto: '30',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'BAZAR',
          seccion: 'Juguete',
          categoria: 'JUGUETE',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 04 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01217',
      fechaIniVigencia: 1670626800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040141700017',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '0,05',
      textoTitulo: 'en CONSOLAS Y VIDEOJUEGOS',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Canjeable en Hipermercados EROS',
      textoDescripcion2: 'KI',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '18.182',
      codImpacto: '1200',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Confeccion',
          categoria: 'CONFECCION HOMBRE',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 10 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01219',
      fechaIniVigencia: 1670626800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030141900019',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en PAN DE MOLDE',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '18.182',
      codImpacto: '1200',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Calzado',
          categoria: 'CALZADO HOMBRE',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 10 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01209',
      fechaIniVigencia: 1670799600000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040140900009',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '50',
      textoTitulo: 'en COLONIAS INFANTILES y de BEBÉ',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '12.770',
      codImpacto: '87332',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Libre servicio',
          categoria: 'PLATOS PREPARADOS CONGELADOS',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Mon Dec 12 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01232',
      fechaIniVigencia: 1670022000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030143200032',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '22',
      textoTitulo: 'en DENTÍFRICOS INFANTILES',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '7.000',
      codImpacto: '11',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ELECTRODOMESTICOS',
          seccion: 'Electro-hogar',
          categoria: 'GAMA BLANCA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 03 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01230',
      fechaIniVigencia: 1670022000000,
      fechaFinVigencia: 'Wed Feb 15 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '15/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030143000030',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '5',
      textoTitulo: 'en HIGIENE INFANTIL',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '15/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '7.000',
      codImpacto: '9',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ELECTRODOMESTICOS',
          seccion: 'Entretenimiento',
          categoria: 'CONSOLAS Y VIDEOJUEGOS',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 03 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01231',
      fechaIniVigencia: 1670022000000,
      fechaFinVigencia: 'Wed Feb 15 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '15/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030143100031',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en CONSERVAS de PESCADO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '15/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '7.000',
      codImpacto: '10',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TOTAL ESTRUCTURA',
          seccion: 'TOTAL ESTRUCTURA',
          categoria: 'TOTAL ESTRUCTURA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 03 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01211',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030141100011',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en AGUACATES',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROSK',
      textoDescripcion2:
        'I, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '6.666',
      codImpacto: '994',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Salado',
          categoria: 'ACEITUNAS Y CURTIDOS',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01218',
      fechaIniVigencia: 1670626800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030141800018',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'PAPELERÍA y MOCHILAS (no libro texto ni diccionarios)',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Canjeable en Hiper EROS',
      textoDescripcion2: 'KI.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.400',
      codImpacto: '200',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Confeccion',
          categoria: 'CONFECCION MUJER',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 10 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01207',
      fechaIniVigencia: 1670886000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040140700007',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '0,50',
      textoTitulo: 'en BRÓCOLI',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROSK',
      textoDescripcion2:
        'I, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.400',
      codImpacto: '8000',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Soluciones culinarias',
          categoria: 'COCINA INSITU',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Tue Dec 13 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01205',
      fechaIniVigencia: 1670972400000,
      fechaFinVigencia: 'Wed Feb 15 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '',
      fechaFinActivacion: '15/02/2023',
      fechaFinCanjeoPromo: '',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030140500005',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en CARNICERÍA',
      textoDescripcion1: 'Ingreso máximo 10€. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '15/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.400',
      codImpacto: '1000',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Salud',
      denominacionSoportePostal: 'Salud',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Panaderia',
          categoria: 'PAN',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'DECORACION',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 16 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01206',
      fechaIniVigencia: 1670972400000,
      fechaFinVigencia: 'Wed Feb 15 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '',
      fechaFinActivacion: '15/02/2023',
      fechaFinCanjeoPromo: '',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040140600006',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '0,05',
      textoTitulo: 'en HIGIENE DEL CABELLO: champú,acondicionador,mascarilla',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '15/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.400',
      codImpacto: '2000',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Mascotas',
      denominacionSoportePostal: 'Mascotas',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TOTAL ESTRUCTURA',
          seccion: 'TOTAL ESTRUCTURA',
          categoria: 'TOTAL ESTRUCTURA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 16 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01214',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030141400014',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en CAFÉ',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.220',
      codImpacto: '995',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Bebidas',
          categoria: 'AGUAS',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01229',
      fechaIniVigencia: 1670108400000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030142900029',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en COCIDOS AVE y CERDO de CHARCUTERIA',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.000',
      codImpacto: '100',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'BAZAR',
          seccion: 'Jardin y playa',
          categoria: 'JARDINERIA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 04 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01222',
      fechaIniVigencia: 1670367600000,
      fechaFinVigencia: 'Tue Feb 14 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '14/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030142200022',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en LIMPIADORES (hogar, suelos, baño, cocina)',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '14/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.000',
      codImpacto: '4',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Carta generica',
      denominacionSoportePostal: 'Carta generica',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'BAZAR',
          seccion: 'Menaje',
          categoria: 'SERVICIO DE MESA',
        },
        {
          area: 'ALIMENTACION',
          seccion: 'Dulce',
          categoria: 'CAFÉ',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Wed Dec 07 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01203',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030140300003',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '22',
      textoTitulo: 'en PAPEL HIGIÉNICO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.234',
      codImpacto: '12345678',
      planAdhesion: 'Ekilibria',
      denominacionPlanAdhesion: 'Ekilibria',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Carniceria',
          categoria: 'MATERIAS AUXILIARES',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'MOBILIARIO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01202',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Tue Feb 14 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '15/02/2023',
      fechaFinActivacion: '14/02/2023',
      fechaFinCanjeoPromo: '15/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030140200002',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en CAFÉ',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '14/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.234',
      codImpacto: '2',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'HORTALIZA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'LAMPARAS',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01204',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Wed Feb 15 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '16/02/2023',
      fechaFinActivacion: '15/02/2023',
      fechaFinCanjeoPromo: '16/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030140400004',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '66,45',
      textoTitulo: 'en CONSERVAS de PESCADO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '15/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.234',
      codImpacto: '3',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Mascotas',
      denominacionSoportePostal: 'Mascotas',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'TOTAL ESTRUCTURA',
          seccion: 'TOTAL ESTRUCTURA',
          categoria: 'TOTAL ESTRUCTURA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01210',
      fechaIniVigencia: 1670799600000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040141000010',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en AGUA',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.123',
      codImpacto: '99999999',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Lacteos',
          categoria: 'LECHE',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Mon Dec 12 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01221',
      fechaIniVigencia: 1670454000000,
      fechaFinVigencia: 'Sun Feb 12 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '13/02/2023',
      fechaFinActivacion: '12/02/2023',
      fechaFinCanjeoPromo: '13/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030142100021',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: 'GRATIS',
      textoTitulo: 'en PESCADERÍA (excepto congelados)',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Ingreso máximo 10 euros. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center o EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '12/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.120',
      codImpacto: '0',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Textil hogar',
          categoria: 'ROPA DE CAMA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 08 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: null,
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01212',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030141200012',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en ENSALADAS en BOLSA (lechuga, rúcula, canónigos...)',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.100',
      codImpacto: '998',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Cocina',
          categoria: 'ACEITE',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01220',
      fechaIniVigencia: 1670540400000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030142000020',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: 'GRATIS',
      textoTitulo: 'en PAPEL HIGIÉNICO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.100',
      codImpacto: '999',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Todo tiempo',
          categoria: 'ROPA INTERIOR',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 09 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: null,
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 1,
      numOferta: '01201',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030140100001',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: false,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en AGUA',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeDD',
      scoring: '0.000',
      codImpacto: '1',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'FRUTA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'BAÑO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01215',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Tue Feb 14 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030141500015',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '22',
      textoTitulo: 'en CEREALES (excepto papillas de cereales)',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '999.999',
      codImpacto: '997',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Drogueria',
          categoria: 'DETERGENTE ROPA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01255',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030145500055',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '22',
      textoTitulo: 'en CEREALES (excepto papillas de cereales)',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '999.999',
      codImpacto: '997',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Drogueria',
          categoria: 'DETERGENTE ROPA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01256',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030145600056',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '5',
      textoTitulo: 'en TABLETAS de CHOCOLATE NEGRO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '801.000',
      codImpacto: '996',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Perfumeria',
          categoria: 'HIGIENE Y CUIDADO CAPILAR',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01253',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030145300053',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '5',
      textoTitulo: 'en CACAO en POLVO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '111.100',
      codImpacto: '999',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Dulce',
          categoria: 'PRODUCTOS SALUD',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01248',
      fechaIniVigencia: 1670886000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040144800048',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '1,50',
      textoTitulo: 'en YOGURES',
      textoDescripcion1: 'Aplicable a 24 packs máximo. Canjeable en Hiper EROS',
      textoDescripcion2: 'KI, Super EROSKI/center, EROSKI/city o EROSKI/online',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '50.100',
      codImpacto: '11',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Carta generica',
      denominacionSoportePostal: 'Carta generica',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Libre servicio',
          categoria: 'HELADO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Tue Dec 13 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01268',
      fechaIniVigencia: 1670108400000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030146800068',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en BOLSITAS y TARRITOS de FRUTAS o VERDURAS',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '30.000',
      codImpacto: '30',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'BAZAR',
          seccion: 'Juguete',
          categoria: 'JUGUETE',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 04 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01257',
      fechaIniVigencia: 1670626800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040145700057',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,05',
      textoTitulo: 'en CONSOLAS Y VIDEOJUEGOS',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Canjeable en Hipermercados EROS',
      textoDescripcion2: 'KI',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '18.182',
      codImpacto: '1200',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Confeccion',
          categoria: 'CONFECCION HOMBRE',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 10 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01259',
      fechaIniVigencia: 1670626800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030145900059',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en PAN DE MOLDE',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '18.182',
      codImpacto: '1200',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Calzado',
          categoria: 'CALZADO HOMBRE',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 10 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01249',
      fechaIniVigencia: 1670799600000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040144900049',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '50',
      textoTitulo: 'en COLONIAS INFANTILES y de BEBÉ',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '12.770',
      codImpacto: '87332',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Libre servicio',
          categoria: 'PLATOS PREPARADOS CONGELADOS',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Mon Dec 12 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01270',
      fechaIniVigencia: 1670022000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '15/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030147000070',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '5',
      textoTitulo: 'en HIGIENE INFANTIL',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '15/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '7.000',
      codImpacto: '9',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ELECTRODOMESTICOS',
          seccion: 'Entretenimiento',
          categoria: 'CONSOLAS Y VIDEOJUEGOS',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 03 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01271',
      fechaIniVigencia: 1670022000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '15/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030147100071',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en CONSERVAS de PESCADO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '15/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '7.000',
      codImpacto: '10',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ELECTRODOMESTICOS',
          seccion: 'Entretenimiento',
          categoria: 'MUSICA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 03 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01272',
      fechaIniVigencia: 1670022000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030147200072',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '22',
      textoTitulo: 'en DENTÍFRICOS INFANTILES',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '7.000',
      codImpacto: '11',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ELECTRODOMESTICOS',
          seccion: 'Electro-hogar',
          categoria: 'GAMA BLANCA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 03 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01251',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030145100051',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en AGUACATES',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROSK',
      textoDescripcion2:
        'I, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '6.666',
      codImpacto: '994',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Salado',
          categoria: 'ACEITUNAS Y CURTIDOS',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01258',
      fechaIniVigencia: 1670626800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030145800058',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'PAPELERÍA y MOCHILAS (no libro texto ni diccionarios)',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Canjeable en Hiper EROS',
      textoDescripcion2: 'KI.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.400',
      codImpacto: '200',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Confeccion',
          categoria: 'CONFECCION MUJER',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 10 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01247',
      fechaIniVigencia: 1670886000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040144700047',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,50',
      textoTitulo: 'en BRÓCOLI',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROSK',
      textoDescripcion2:
        'I, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.400',
      codImpacto: '8000',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Soluciones culinarias',
          categoria: 'COCINA INSITU',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Tue Dec 13 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01254',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030145400054',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en CAFÉ',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.220',
      codImpacto: '995',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Bebidas',
          categoria: 'AGUAS',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01262',
      fechaIniVigencia: 1670367600000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '14/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030146200062',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en LIMPIADORES (hogar, suelos, baño, cocina)',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '14/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.000',
      codImpacto: '4',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Carta generica',
      denominacionSoportePostal: 'Carta generica',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'BAZAR',
          seccion: 'Menaje',
          categoria: 'SERVICIO DE MESA',
        },
        {
          area: 'ALIMENTACION',
          seccion: 'Dulce',
          categoria: 'CAFÉ',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Wed Dec 07 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01269',
      fechaIniVigencia: 1670108400000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030146900069',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en COCIDOS AVE y CERDO de CHARCUTERIA',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.000',
      codImpacto: '100',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'BAZAR',
          seccion: 'Jardin y playa',
          categoria: 'JARDINERIA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 04 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01243',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030144300043',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '22',
      textoTitulo: 'en PAPEL HIGIÉNICO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.234',
      codImpacto: '12345678',
      planAdhesion: 'Ekilibria',
      denominacionPlanAdhesion: 'Ekilibria',
      soportePostal: 'Salud',
      denominacionSoportePostal: 'Salud',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Carniceria',
          categoria: 'MATERIAS AUXILIARES',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'MOBILIARIO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01242',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Tue Feb 14 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '15/02/2023',
      fechaFinActivacion: '14/02/2023',
      fechaFinCanjeoPromo: '15/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030144200042',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en CAFÉ',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '14/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.234',
      codImpacto: '2',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'HORTALIZA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'LAMPARAS',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01244',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Wed Feb 15 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '16/02/2023',
      fechaFinActivacion: '15/02/2023',
      fechaFinCanjeoPromo: '16/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030144400044',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '66,45',
      textoTitulo: 'en CONSERVAS de PESCADO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '15/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.234',
      codImpacto: '3',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Mascotas',
      denominacionSoportePostal: 'Mascotas',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Charcuteria',
          categoria: 'QUESOS MOSTRADOR',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'DESCANSO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01250',
      fechaIniVigencia: 1670799600000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040145000050',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en AGUA',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.123',
      codImpacto: '99999999',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Lacteos',
          categoria: 'LECHE',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Mon Dec 12 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01261',
      fechaIniVigencia: 1670454000000,
      fechaFinVigencia: 'Sun Feb 12 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '13/02/2023',
      fechaFinActivacion: '12/02/2023',
      fechaFinCanjeoPromo: '13/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030146100061',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: 'GRATIS',
      textoTitulo: 'en PESCADERÍA (excepto congelados)',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Ingreso máximo 10 euros. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center o EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '12/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.120',
      codImpacto: '0',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Textil hogar',
          categoria: 'ROPA DE CAMA',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 08 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: null,
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01252',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030145200052',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en ENSALADAS en BOLSA (lechuga, rúcula, canónigos...)',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.100',
      codImpacto: '998',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Cocina',
          categoria: 'ACEITE',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01260',
      fechaIniVigencia: 1670540400000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030146000060',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: 'GRATIS',
      textoTitulo: 'en PAPEL HIGIÉNICO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.100',
      codImpacto: '999',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Todo tiempo',
          categoria: 'ROPA INTERIOR',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 09 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: null,
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 2,
      numOferta: '01241',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030144100041',
      exclusividad: true,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en AGUA',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeDD',
      scoring: '0.000',
      codImpacto: '1',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'FRUTA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'BAÑO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01310',
      fechaIniVigencia: 1670022000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '15/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030151000110',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '5',
      textoTitulo: 'en HIGIENE INFANTIL',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '15/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '7.000',
      codImpacto: '9',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ELECTRODOMESTICOS',
          seccion: 'Entretenimiento',
          categoria: 'CONSOLAS Y VIDEOJUEGOS',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670022000000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 03 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01311',
      fechaIniVigencia: 1670022000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '15/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030151100111',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en CONSERVAS de PESCADO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '15/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '7.000',
      codImpacto: '10',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ELECTRODOMESTICOS',
          seccion: 'Entretenimiento',
          categoria: 'MUSICA',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670022000000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 03 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01312',
      fechaIniVigencia: 1670022000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030151200112',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '22',
      textoTitulo: 'en DENTÍFRICOS INFANTILES',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '7.000',
      codImpacto: '11',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ELECTRODOMESTICOS',
          seccion: 'Electro-hogar',
          categoria: 'GAMA BLANCA',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670022000000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 03 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01308',
      fechaIniVigencia: 1670108400000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030150800108',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en BOLSITAS y TARRITOS de FRUTAS o VERDURAS',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '30.000',
      codImpacto: '30',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'BAZAR',
          seccion: 'Juguete',
          categoria: 'JUGUETE',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670108400000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 04 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01309',
      fechaIniVigencia: 1670108400000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030150900109',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en COCIDOS AVE y CERDO de CHARCUTERIA',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.000',
      codImpacto: '100',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'BAZAR',
          seccion: 'Jardin y playa',
          categoria: 'JARDINERIA',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670108400000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 04 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01302',
      fechaIniVigencia: 1670367600000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '14/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030150200102',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en LIMPIADORES (hogar, suelos, baño, cocina)',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '14/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.000',
      codImpacto: '4',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Carta generica',
      denominacionSoportePostal: 'Carta generica',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'BAZAR',
          seccion: 'Menaje',
          categoria: 'SERVICIO DE MESA',
        },
        {
          area: 'ALIMENTACION',
          seccion: 'Dulce',
          categoria: 'CAFÉ',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670367600000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Wed Dec 07 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01301',
      fechaIniVigencia: 1670454000000,
      fechaFinVigencia: 'Sun Feb 12 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '13/02/2023',
      fechaFinActivacion: '12/02/2023',
      fechaFinCanjeoPromo: '13/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030150100101',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: 'GRATIS',
      textoTitulo: 'en PESCADERÍA (excepto congelados)',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Ingreso máximo 10 euros. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center o EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '12/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.120',
      codImpacto: '0',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Textil hogar',
          categoria: 'ROPA DE CAMA',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670454000000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 08 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: null,
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01300',
      fechaIniVigencia: 1670540400000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030150000100',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: 'GRATIS',
      textoTitulo: 'en PAPEL HIGIÉNICO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.100',
      codImpacto: '999',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Todo tiempo',
          categoria: 'ROPA INTERIOR',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670540400000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 09 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: null,
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01297',
      fechaIniVigencia: 1670626800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040149700097',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '0,05',
      textoTitulo: 'en CONSOLAS Y VIDEOJUEGOS',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Canjeable en Hipermercados EROS',
      textoDescripcion2: 'KI',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '18.182',
      codImpacto: '1200',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Confeccion',
          categoria: 'CONFECCION HOMBRE',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670626800000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 10 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01299',
      fechaIniVigencia: 1670626800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030149900099',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en PAN DE MOLDE',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '18.182',
      codImpacto: '1200',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Calzado',
          categoria: 'CALZADO HOMBRE',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670626800000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 10 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01298',
      fechaIniVigencia: 1670626800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030149800098',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'PAPELERÍA y MOCHILAS (no libro texto ni diccionarios)',
      textoDescripcion1:
        'Por una compra igual o superior a 2 unidades. Canjeable en Hiper EROS',
      textoDescripcion2: 'KI.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.400',
      codImpacto: '200',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'TEXTIL',
          seccion: 'Confeccion',
          categoria: 'CONFECCION MUJER',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670626800000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sat Dec 10 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01295',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030149500095',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '22',
      textoTitulo: 'en CEREALES (excepto papillas de cereales)',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '999.999',
      codImpacto: '997',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Drogueria',
          categoria: 'DETERGENTE ROPA',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670713200000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01296',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030149600096',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '5',
      textoTitulo: 'en TABLETAS de CHOCOLATE NEGRO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '801.000',
      codImpacto: '996',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Perfumeria',
          categoria: 'HIGIENE Y CUIDADO CAPILAR',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670713200000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01293',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030149300093',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '5',
      textoTitulo: 'en CACAO en POLVO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '111.100',
      codImpacto: '999',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Dulce',
          categoria: 'PRODUCTOS SALUD',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670713200000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01291',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030149100091',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en AGUACATES',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROSK',
      textoDescripcion2:
        'I, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '6.666',
      codImpacto: '994',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Salado',
          categoria: 'ACEITUNAS Y CURTIDOS',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670713200000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01294',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030149400094',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en CAFÉ',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.220',
      codImpacto: '995',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Bebidas',
          categoria: 'AGUAS',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670713200000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01292',
      fechaIniVigencia: 1670713200000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030149200092',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en ENSALADAS en BOLSA (lechuga, rúcula, canónigos...)',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.100',
      codImpacto: '998',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Cocina',
          categoria: 'ACEITE',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670713200000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Sun Dec 11 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01289',
      fechaIniVigencia: 1670799600000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040148900089',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '50',
      textoTitulo: 'en COLONIAS INFANTILES y de BEBÉ',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '12.770',
      codImpacto: '87332',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Libre servicio',
          categoria: 'PLATOS PREPARADOS CONGELADOS',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670799600000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Mon Dec 12 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01290',
      fechaIniVigencia: 1670799600000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040149000090',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '100',
      textoTitulo: 'en AGUA',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.123',
      codImpacto: '99999999',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Lacteos',
          categoria: 'LECHE',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670799600000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Mon Dec 12 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01288',
      fechaIniVigencia: 1670886000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040148800088',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '1,50',
      textoTitulo: 'en YOGURES',
      textoDescripcion1: 'Aplicable a 24 packs máximo. Canjeable en Hiper EROS',
      textoDescripcion2: 'KI, Super EROSKI/center, EROSKI/city o EROSKI/online',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '50.100',
      codImpacto: '11',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Carta generica',
      denominacionSoportePostal: 'Carta generica',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'ALIMENTACION',
          seccion: 'Libre servicio',
          categoria: 'HELADO',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670886000000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Tue Dec 13 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01287',
      fechaIniVigencia: 1670886000000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2040148700087',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '0,50',
      textoTitulo: 'en BRÓCOLI',
      textoDescripcion1: 'Ingreso máximo 10 euros. Canjeable en Hiper EROSK',
      textoDescripcion2:
        'I, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '2.400',
      codImpacto: '8000',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Sin carta/postal',
      denominacionSoportePostal: 'Sin carta/postal',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Soluciones culinarias',
          categoria: 'COCINA INSITU',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1670886000000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Tue Dec 13 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '%',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01282',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Tue Feb 14 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '15/02/2023',
      fechaFinActivacion: '14/02/2023',
      fechaFinCanjeoPromo: '15/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030148200082',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '10,50',
      textoTitulo: 'en CAFÉ',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '14/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.234',
      codImpacto: '2',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'HORTALIZA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'LAMPARAS',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1671058800000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01284',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Wed Feb 15 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '16/02/2023',
      fechaFinActivacion: '15/02/2023',
      fechaFinCanjeoPromo: '16/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030148400084',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '66,45',
      textoTitulo: 'en CONSERVAS de PESCADO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '15/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.234',
      codImpacto: '3',
      planAdhesion: 'Sin informar',
      denominacionPlanAdhesion: 'Sin informar',
      soportePostal: 'Mascotas',
      denominacionSoportePostal: 'Mascotas',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Charcuteria',
          categoria: 'QUESOS MOSTRADOR',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'DESCANSO',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1671058800000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01283',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030148300083',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '22',
      textoTitulo: 'en PAPEL HIGIÉNICO',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROSK',
      textoDescripcion2: 'I, Super EROSKI/center, EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '0.234',
      codImpacto: '12345678',
      planAdhesion: 'Ekilibria',
      denominacionPlanAdhesion: 'Ekilibria',
      soportePostal: 'Salud',
      denominacionSoportePostal: 'Salud',
      valeDestacado: '1',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Carniceria',
          categoria: 'MATERIAS AUXILIARES',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'MOBILIARIO',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1671058800000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 3,
      numOferta: '01281',
      fechaIniVigencia: 1671058800000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '14/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '14/02/2023',
      visualizar: true,
      activable: true,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030148100081',
      exclusividad: true,
      entregada: false,
      canjeada: true,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en AGUA',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: 'WEB',
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeDD',
      scoring: '0.000',
      codImpacto: '1',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'FRUTA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'BAÑO',
        },
      ],
      tienda: 'EROSKI ABADIÑO',
      fechaCanjeo: 1671058800000,
      horaCanjeo: 3601000,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Thu Dec 15 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    {
      tipoLista: 4,
      numOferta: '01321',
      fechaIniVigencia: 1670972400000,
      fechaFinVigencia: 'Mon Feb 13 00:00:00 CET 2023',
      fechaFinCanjeoDTO: '13/02/2023',
      fechaFinActivacion: '13/02/2023',
      fechaFinCanjeoPromo: '13/02/2023',
      visualizar: true,
      activable: false,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030152100121',
      exclusividad: false,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en AGUA',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: null,
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '3.000',
      codImpacto: '1',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'FRUTA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'BAÑO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 16 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
    },
    // VALES MASIVOS
    {
      tipoLista: 1,
      numOferta: '01321',
      fechaIniVigencia: 1670972400000,
      fechaFinVigencia: 'Mon Dec 13 00:00:00 CET 2024',
      fechaFinCanjeoDTO: '13/12/2024',
      fechaFinActivacion: '13/11/2024',
      fechaFinCanjeoPromo: '13/12/2024',
      visualizar: true,
      activable: false,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030152100121',
      exclusividad: false,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en CARNICERÍA y EMBUTIDOS',
      textoDescripcion1: 'compra mínima 25€',
      textoDescripcion2:
        'Canjeable en tiendas EROSKI. Compra mínima total de 25€ para el canjeo de cada vale. Posible canjear más de un vale siempre que se cumpla el requisito de 50€ de compra por cada vale.',
      canalActivacion: null,
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '3.000',
      codImpacto: '1',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'FRUTA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'BAÑO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 16 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
      masivo: true,
    },
    {
      tipoLista: 1,
      numOferta: '01321',
      fechaIniVigencia: 1670972400000,
      fechaFinVigencia: 'Mon Dec 13 00:00:00 CET 2024',
      fechaFinCanjeoDTO: '13/12/2024',
      fechaFinActivacion: '13/11/2024',
      fechaFinCanjeoPromo: '13/12/2024',
      visualizar: true,
      activable: false,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030152100121',
      exclusividad: false,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en MASIVOS 2',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: null,
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '3.000',
      codImpacto: '1',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'FRUTA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'BAÑO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 16 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
      masivo: true,
    },
    {
      tipoLista: 1,
      numOferta: '01321',
      fechaIniVigencia: 1670972400000,
      fechaFinVigencia: 'Mon Dec 13 00:00:00 CET 2024',
      fechaFinCanjeoDTO: '13/12/2024',
      fechaFinActivacion: '13/11/2024',
      fechaFinCanjeoPromo: '13/12/2024',
      visualizar: true,
      activable: false,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030152100121',
      exclusividad: false,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en MASIVOS 3',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: null,
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '3.000',
      codImpacto: '1',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'FRUTA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'BAÑO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 16 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
      masivo: true,
    },
    {
      tipoLista: 1,
      numOferta: '01321',
      fechaIniVigencia: 1670972400000,
      fechaFinVigencia: 'Mon Dec 13 00:00:00 CET 2024',
      fechaFinCanjeoDTO: '13/12/2024',
      fechaFinActivacion: '13/11/2024',
      fechaFinCanjeoPromo: '13/12/2024',
      visualizar: true,
      activable: false,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030152100121',
      exclusividad: false,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en MASIVOS 4',
      textoDescripcion1:
        'Aplicable a 24 unidades máximo. Canjeable en Hiper EROS',
      textoDescripcion2:
        'KI, Super EROSKI/center,  EROSKI/city o EROSKI/online.',
      canalActivacion: null,
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '3.000',
      codImpacto: '1',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'FRUTA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'BAÑO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 16 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
      masivo: true,
    },
    {
      tipoLista: 2,
      numOferta: '01321',
      fechaIniVigencia: 1670972400000,
      fechaFinVigencia: 'Mon Dec 13 00:00:00 CET 2024',
      fechaFinCanjeoDTO: '13/12/2024',
      fechaFinActivacion: '13/11/2024',
      fechaFinCanjeoPromo: '13/12/2024',
      visualizar: true,
      activable: false,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030152100121',
      exclusividad: false,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en CARNICERÍA y EMBUTIDOS',
      textoDescripcion1: 'compra mínima 25€',
      textoDescripcion2:
        'Canjeable en tiendas EROSKI. Compra mínima total de 25€ para el canjeo de cada vale. Posible canjear más de un vale siempre que se cumpla el requisito de 50€ de compra por cada vale.',
      canalActivacion: null,
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '3.000',
      codImpacto: '1',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'FRUTA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'BAÑO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 16 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
      masivo: true,
    },
    {
      tipoLista: 3,
      numOferta: '01321',
      fechaIniVigencia: 1670972400000,
      fechaFinVigencia: 'Mon Dec 13 00:00:00 CET 2024',
      fechaFinCanjeoDTO: '13/12/2024',
      fechaFinActivacion: '13/11/2024',
      fechaFinCanjeoPromo: '13/12/2024',
      visualizar: true,
      activable: false,
      grupoInternoVisualizar: '000',
      grupoInternoActivacion: '000',
      valeEAN: '2030152100121',
      exclusividad: false,
      entregada: false,
      canjeada: false,
      activada: true,
      idioma: '2',
      textoReclamo: '0,08',
      textoTitulo: 'en CARNICERÍA y EMBUTIDOS',
      textoDescripcion1: 'compra mínima 25€',
      textoDescripcion2:
        'Canjeable en tiendas EROSKI. Compra mínima total de 25€ para el canjeo de cada vale. Posible canjear más de un vale siempre que se cumpla el requisito de 50€ de compra por cada vale.',
      canalActivacion: null,
      canalesVisualizacion: ['APP', 'WEB'],
      fechaActivacion: '13/02/2023',
      tipoVale: 'ValeMonedero',
      scoring: '3.000',
      codImpacto: '1',
      planAdhesion: 'Plan Familias',
      denominacionPlanAdhesion: 'Plan Familias',
      soportePostal: 'ReporClub',
      denominacionSoportePostal: 'ReporClub',
      valeDestacado: '0',
      estructurasComerciales: [
        {
          area: 'FRESCOS',
          seccion: 'Fruta y hortaliza',
          categoria: 'FRUTA',
        },
        {
          area: 'BAZAR',
          seccion: 'Hogar',
          categoria: 'BAÑO',
        },
      ],
      tienda: null,
      fechaCanjeo: null,
      horaCanjeo: null,
      locale: 'es',
      preferencia: 'ED',
      fechaInicioCanjeo: 'Fri Dec 16 00:00:00 CET 2022',
      showValeEntrega: true,
      tipoReclamo: '€',
      valeEntregado: null,
      showPopup: false,
      masivo: true,
    },
  ];

  getValesResponse = () => {
    const data = {
      error: false,
      pojos: this.pojos,
    };
    return data;
  };

  setActivado = (vale: any) => {
    this.pojos.filter((pojo) => this.setVale(pojo, vale));
  };

  private setVale = (pojo: any, vale: any) => {
    if (pojo.numOferta === vale.numOferta) {
      pojo.tipoLista = 2;
    }
    return pojo;
  };

  getPreferenciaResponse = () => {
    const data = { error: false, preferencia: 'CC', codRespuesta: '200' };
    return data;
  };
}
